const UploadPreviewState = ({
  children,
  uploading = false,
  progress = 0,
  error = "",
  className = "",
}) => {
  const percentage = Math.max(0, Math.min(100, Number(progress) || 0));
  const active = uploading && percentage < 100 && !error;

  return (
    <div className={`relative h-full w-full overflow-hidden rounded-xl ${className}`}>
      <div className={`h-full w-full transition ${active || error ? "grayscale opacity-50" : ""}`}>
        {children}
      </div>
      {active && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#19295C]/20 px-4">
          <div className="rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-[#175dc0] shadow">
            {percentage}%
          </div>
          <div className="mt-2 h-2 w-full max-w-[150px] overflow-hidden rounded-full bg-white/80 shadow">
            <div
              className="h-full rounded-full bg-gradient-to-r from-[#0022AA] to-[#1A64B9] transition-all duration-200"
              style={{width: `${percentage}%`}}
            />
          </div>
        </div>
      )}
      {error && (
        <div className="absolute inset-x-2 bottom-2 rounded-lg bg-red-600/95 px-2 py-1 text-center text-[11px] font-medium text-white shadow">
          {error}
        </div>
      )}
    </div>
  );
};

export default UploadPreviewState;
